import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { HomeService } from '../_services/home.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ErrorMessageService } from '../services/error-message.service';
import { NgSelectModule, } from '@ng-select/ng-select';
import { MatDialog } from '@angular/material/dialog';
import { RentAgreementModalComponent } from './rent-agreement-modal.component';
import { AuthService } from '../_services/auth.service';
import { RentAgreementFormService } from '../_services/rent-agreement-form.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-rent-agreement',
  templateUrl: './rent-agreement.component.html',
  styleUrls: ['./rent-agreement.component.scss']
})
export class RentAgreementComponent implements OnInit {
  stateDataList: any[] = [];
  cityDataList: any[] = [];
  cityDataList1: any[] = [];
  cityDataList2: any[] = [];
  selectedCityName: any
  selectedCityName1: any
  selectedCityName2: any
  step = 1;
  progress: number = 0;

  formData: any;
  selectedCity: any;
  stateId: any;
  stateName: any;
  stateName1: any;
  stateName2: any;
  rentAgreementForm: FormGroup;
  isSubmitted = false;
  constructor(private fb: FormBuilder,
    private dialog: MatDialog,
    private homeService: HomeService,
    private router: Router,
    private route: ActivatedRoute,
    private cd: ChangeDetectorRef,
    private toastr: ToastrService,
    private errorMessageService: ErrorMessageService,
    private cdr: ChangeDetectorRef,
    private authService: AuthService,
    private cdRef: ChangeDetectorRef,
    private rentAgreementFormService: RentAgreementFormService
  ) { }
  ngOnInit(): void {

    const emptysearch = ''
    this.getCitybyCountryId(emptysearch);
    this.getCitybyCountryId1(emptysearch);
    this.getCitybyCountryId2(emptysearch);
    this.getPhoneCode();

    this.rentAgreementForm = this.fb.group({
      propertyAddress: ['', Validators.required],
      propertyLocality: ['', Validators.required],
      propertyCityId: ['', Validators.required],
      propertyStateId: ['', Validators.required],

      rentPerMonth: ['', Validators.required],
      totalSecurity: ['', Validators.required],
      startDate: ['', Validators.required],
      endDate: ['', Validators.required],

      ownerFullName: ['', Validators.required],
      ownerFatherName: ['', Validators.required],
      ownerAddress: ['', Validators.required],
      ownerLocality: ['', Validators.required],
      ownerCityId: ['', Validators.required],
      ownerStateId: ['', Validators.required],
      ownerMobileNumber: ['', Validators.required],
      ownerEmail: ['', [Validators.required, Validators.email]],
      ownerAadharNumber: ['', Validators.required],

      tenantFullName: ['', Validators.required],
      tenantFatherName: ['', Validators.required],
      tenantAddress: ['', Validators.required],
      tenantLocality: ['', Validators.required],
      tenantCityId: ['', Validators.required],
      tenantStateId: ['', Validators.required],
      tenantMobileNumber: ['', Validators.required],
      tenantEmail: ['', [Validators.required, Validators.email]],
      tenantAadharNumber: ['', Validators.required],
      tenantMobileCode: ['+91', Validators.required],
      ownerMobileCode: ['+91', Validators.required],
    });
    this.cdRef.detectChanges();
    const savedData = this.rentAgreementFormService.getFormData();
    console.log('savedData==================>', savedData);

    if (savedData) {
      const formFields = {
        propertyAddress: savedData.propertyAddress,
        propertyLocality: savedData.propertyLocality,
        propertyCityId: savedData.propertyCityId,
        propertyStateId: savedData.propertyStateId,
        rentPerMonth: savedData.rentPerMonth,
        totalSecurity: savedData.totalSecurity,
        startDate: savedData.startDate,
        endDate: savedData.endDate,
        ownerFullName: savedData.ownerFullName,
        ownerFatherName: savedData.ownerFatherName,
        ownerAddress: savedData.ownerAddress,
        ownerLocality: savedData.ownerLocality,
        ownerCityId: savedData.ownerCityId,
        ownerStateId: savedData.ownerStateId,
        ownerMobileNumber: savedData.ownerMobileNumber,
        ownerEmail: savedData.ownerEmail,
        ownerAadharNumber: savedData.ownerAadharNumber,
        ownerMobileCode: savedData.ownerMobileCode,
        tenantFullName: savedData.tenantFullName,
        tenantFatherName: savedData.tenantFatherName,
        tenantAddress: savedData.tenantAddress,
        tenantLocality: savedData.tenantLocality,
        tenantCityId: savedData.tenantCityId,
        tenantStateId: savedData.tenantStateId,
        tenantMobileNumber: savedData.tenantMobileNumber,
        tenantEmail: savedData.tenantEmail,
        tenantAadharNumber: savedData.tenantAadharNumber,
        tenantMobileCode: savedData.tenantMobileCode
      };

      this.rentAgreementForm.patchValue(formFields);
    }
    this.rentAgreementForm.valueChanges.subscribe(() => {
      this.updateProgress();
    });

    // Optional: initialize progress on load
    this.updateProgress();

  }

  onCitySearch(event: { term: string; items: any[] }) {
    const searchTerm = event.term;
    if (searchTerm && searchTerm.length >= 3) {
      this.getCitybyCountryId(searchTerm);
    }
  }
  onCitySearch1(event: { term: string; items: any[] }) {
    const searchTerm = event.term;
    if (searchTerm && searchTerm.length >= 3) {
      this.getCitybyCountryId1(searchTerm);
    }
  }
  onCitySearch2(event: { term: string; items: any[] }) {
    const searchTerm = event.term;
    if (searchTerm && searchTerm.length >= 3) {
      this.getCitybyCountryId2(searchTerm);
    }
  }

  getCitybyCountryId(searchText: string) {
    this.homeService.searchCity(searchText).subscribe(
      (response: any) => {
        if (response.status === 'SUCCESS') {
          this.cityDataList = response.payload.map(city => ({
            name: city.name,
            id: city.id,
            value: { id: city.id, name: city.name }  // bindValue object
          }));
        } else {
          console.error('Failed to fetch city data:', response);
        }
      },
      (error) => {
        const message = error?.error?.message || 'You are not authorized to access this page';
        if (message) {
          let errorMessage = this.errorMessageService.getErrorMessage(message);
          this.toastr.error(errorMessage, 'Error');
        }


      }
    );
  }
  getCitybyCountryId1(searchText: string) {
    this.homeService.searchCity(searchText).subscribe(
      (response: any) => {
        if (response.status === 'SUCCESS') {
          this.cityDataList1 = response.payload.map(city => ({
            name: city.name,
            id: city.id,
            value: { id: city.id, name: city.name }  // bindValue object
          }));
        } else {
          console.error('Failed to fetch city data:', response);
        }
      },
      (error) => {
        const message = error?.error?.message || 'You are not authorized to access this page';
        if (message) {
          let errorMessage = this.errorMessageService.getErrorMessage(message);
          this.toastr.error(errorMessage, 'Error');
        }


      }
    );
  }
  getCitybyCountryId2(searchText: string) {
    this.homeService.searchCity(searchText).subscribe(
      (response: any) => {
        if (response.status === 'SUCCESS') {
          this.cityDataList2 = response.payload.map(city => ({
            name: city.name,
            id: city.id,
            value: { id: city.id, name: city.name }  // bindValue object
          }));
        } else {
          console.error('Failed to fetch city data:', response);
        }
      },
      (error) => {
        const message = error?.error?.message || 'You are not authorized to access this page';
        if (message) {
          let errorMessage = this.errorMessageService.getErrorMessage(message);
          this.toastr.error(errorMessage, 'Error');
        }


      }
    );
  }
  getStateByCityId(cityId: number) {
    this.homeService.searchstate(cityId).subscribe(
      (response: any) => {
        if (response.status === 'SUCCESS') {
          const stateId = response.payload.stateId;
          const stateName = response.payload.stateName;
          this.stateName = response.payload.stateName;


          this.stateDataList = [{
            name: stateName,
            id: stateId,
            value: { id: stateId, name: stateName }
          }];

          this.rentAgreementForm.patchValue({
            propertyStateId: stateId
          });

          this.cd.detectChanges();
        }
      },
      (error) => {
        const message = error?.error?.message || 'You are not authorized to access this page';
        const errorMessage = this.errorMessageService.getErrorMessage(message);
        this.toastr.error(errorMessage, 'Error');
      }
    );
  }
  getStateByCityId1(cityId: number) {
    this.homeService.searchstate(cityId).subscribe(
      (response: any) => {
        if (response.status === 'SUCCESS') {
          const stateId = response.payload.stateId;
          const stateName = response.payload.stateName;
          this.stateName1 = response.payload.stateName;

          this.stateDataList = [{
            name: stateName,
            id: stateId,
            value: { id: stateId, name: stateName }
          }];

          this.rentAgreementForm.patchValue({
            ownerStateId: stateId
          });

          this.cd.detectChanges();
        }
      },
      (error) => {
        const message = error?.error?.message || 'You are not authorized to access this page';
        const errorMessage = this.errorMessageService.getErrorMessage(message);
        this.toastr.error(errorMessage, 'Error');
      }
    );
  }
  getStateByCityId2(cityId: number) {
    this.homeService.searchstate(cityId).subscribe(
      (response: any) => {
        if (response.status === 'SUCCESS') {
          const stateId = response.payload.stateId;
          const stateName = response.payload.stateName;
          this.stateName2 = response.payload.stateName;

          this.stateDataList = [{
            name: stateName,
            id: stateId,
            value: { id: stateId, name: stateName }
          }];

          this.rentAgreementForm.patchValue({
            tenantStateId: stateId
          });

          this.cd.detectChanges();
        }
      },
      (error) => {
        const message = error?.error?.message || 'You are not authorized to access this page';
        const errorMessage = this.errorMessageService.getErrorMessage(message);
        this.toastr.error(errorMessage, 'Error');
      }
    );
  }

  onCityChange(event: any) {
    console.log('onCityChange triggered');
    this.selectedCity = event?.value.id;
    this.selectedCityName = event?.value.name;
    console.log("this.selectedCity", this.selectedCity);
    this.getStateByCityId(this.selectedCity);
  }

  onCityChange1(event: any) {
    console.log('onCityChange triggered');
    this.selectedCity = event?.value.id;
    this.selectedCityName1 = event?.value.name;
    console.log("this.selectedCity", this.selectedCity);
    this.getStateByCityId1(this.selectedCity);
  }

  onCityChange2(event: any) {
    console.log('onCityChange triggered');
    this.selectedCity = event?.value.id;
    this.selectedCityName2 = event?.value.name;
    console.log("this.selectedCity", this.selectedCity);
    this.getStateByCityId2(this.selectedCity);
  }

  // onSubmit() {
  //   console.log(this.rentAgreementForm.value);
  //   if (this.rentAgreementForm.valid) {
  //     console.log(this.rentAgreementForm.value);
  //     let payload = this.rentAgreementForm.value
  //     this.rentAgreementFormService.setFormData(payload);
  //     let PopUpvalue = {
  //       ...payload,
  //       selectedCityName: this.selectedCityName,
  //       selectedCityName1: this.selectedCityName1,
  //       selectedCityName2: this.selectedCityName2,
  //       stateName: this.stateName,
  //       stateName1: this.stateName1,
  //       stateName2: this.stateName2,
  //     }
  //     console.log('PopUpvalue===================>', PopUpvalue);
  //     this.router.navigate(['/rent-agreement-template'], { state: { data: PopUpvalue } });
  //     this.homeService.SaveRentAgreement(payload).subscribe({
  //       next: (response: any) => {
  //         if (response.status === 'SUCCESS') {
  //           this.toastr.success('Rent Agreement Saved Successfully', 'Success');
  //         } else {
  //         }
  //       },

  //     });
  //   }

  // }
  onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/[^0-9]/g, ''); // Remove any non-digit characters
    if (input.value.length > 6) {
      input.value = input.value.slice(0, 6); // Limit to 10 digits
    }
  }
  mobileonInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/[^0-9]/g, '');
    if (input.value.length > 10) {
      input.value = input.value.slice(0, 10);
    }
  }
  adharInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/[^0-9]/g, '');
    if (input.value.length > 12) {
      input.value = input.value.slice(0, 12);
    }
  }
  hasError(controlName: string): boolean {
    const control = this.rentAgreementForm.get(controlName);
    return control?.hasError('required') && (control.touched || this.isSubmitted);
  }

  onSubmit() {
    this.isSubmitted = true;
    console.log(this.rentAgreementForm.value);
    if (this.rentAgreementForm.invalid) {
      this.rentAgreementForm.markAllAsTouched(); // shows all validation errors
      return;
    }
    if (this.rentAgreementForm.valid) {
      let payload = this.rentAgreementForm.value;
      this.rentAgreementFormService.setFormData(payload);

      const PopUpvalue = {
        ...payload,
        selectedCityName: this.selectedCityName,
        selectedCityName1: this.selectedCityName1,
        selectedCityName2: this.selectedCityName2,
        stateName: this.stateName,
        stateName1: this.stateName1,
        stateName2: this.stateName2,
      };

      this.homeService.SaveRentAgreement(payload).subscribe({
        next: (response: any) => {
          if (response.status === 'SUCCESS') {
            this.toastr.success('Rent Agreement Saved Successfully', 'Success');

            // Show confirmation popup
            Swal.fire({
              title: 'Your Rent Agreement is ready. Please review and edit it (if required) as per your requirement',
              icon: 'success',
              confirmButtonText: 'OK',
              customClass: {
                confirmButton: 'custom-ok-button'
              }
            }).then(result => {
              if (result.isConfirmed) {
                this.router.navigate(['/rent-agreement-template'], {
                  state: { data: PopUpvalue }
                });
              }
            });

          } else {
            this.toastr.error('Failed to save Rent Agreement', 'Error');
          }
        },
        error: () => {
          this.toastr.error('API Error. Please try again.', 'Error');
        }
      });
    }
  }


  openrentAgreementDialog(formData): void {
    console.log('formData', formData);
    this.dialog.open(RentAgreementModalComponent, {
      data: formData,
      width: '60%',
      height: '80%'
    });
  }

  mobileCode: string[] = [];
  selectedPhoneCode: string = "+91"; // Always default to +91

  getPhoneCode() {
    this.authService.getphonecode().subscribe(
      (response: any) => {
        if (response && response.errorCode === 0 && response.payload) {
          this.mobileCode = response.payload
          if (!this.mobileCode.includes("+91")) {
            this.mobileCode.unshift("+91");
          }

        }
      },
      (error) => {
        console.error("Error fetching phone codes:", error);

      }
    );
  }


  nextStep() {
    let controlsToCheck = [];

    if (this.step === 1) {
      controlsToCheck = [
        'propertyAddress',
        'propertyLocality',
        'propertyCityId',
        'propertyStateId',
        'rentPerMonth',
        'totalSecurity',
        'startDate',
        'endDate'
      ];
    } else if (this.step === 2) {
      controlsToCheck = [
        'ownerFullName',
        'ownerFatherName',
        'ownerAddress',
        'ownerLocality',
        'ownerCityId',
        'ownerStateId',
        'ownerMobileNumber',
        'ownerMobileCode',
        'ownerEmail',
        'ownerAadharNumber'
      ];
    } else if (this.step === 3) {
      controlsToCheck = [
        'tenantFullName',
        'tenantFatherName',
        'tenantAddress',
        'tenantLocality',
        'tenantCityId',
        'tenantStateId',
        'tenantMobileNumber',
        'tenantMobileCode',
        'tenantEmail',
        'tenantAadharNumber'
      ];
    }

    let allValid = true;
    for (const controlName of controlsToCheck) {
      const control = this.rentAgreementForm.get(controlName);
      if (control) {
        control.markAsTouched(); // To show validation errors in UI
        control.updateValueAndValidity();
        if (control.invalid) {
          allValid = false;
        }
      }
    }

    if (allValid && this.step < 4) {
      this.step++;
      this.updateProgress();
      this.cdr.detectChanges();
    }
  }

  prevStep() {
    if (this.step > 1) {
      this.step--;
      this.updateProgress();
      this.cdr.detectChanges();
    }
  }
  stepFieldMap: { [key: number]: string[] } = {
    1: ['propertyAddress',
      'propertyLocality',
      'propertyCityId',
      'propertyStateId',
      'rentPerMonth',
      'totalSecurity',
      'startDate',
      'endDate'],
    2: ['ownerFullName',
      'ownerFatherName',
      'ownerAddress',
      'ownerLocality',
      'ownerCityId',
      'ownerStateId',
      'ownerMobileNumber',
      'ownerMobileCode',
      'ownerEmail',
      'ownerAadharNumber'],
    3: ['tenantFullName',
      'tenantFatherName',
      'tenantAddress',
      'tenantLocality',
      'tenantCityId',
      'tenantStateId',
      'tenantMobileNumber',
      'tenantMobileCode',
      'tenantEmail',
      'tenantAadharNumber'],
  }

  updateProgress() {
    let completedSteps = 0;
    const totalSteps = Object.keys(this.stepFieldMap).length;

    for (const [step, fields] of Object.entries(this.stepFieldMap)) {
      const allValid = fields.every(field => {
        const control = this.rentAgreementForm.get(field);
        return control && control.valid && control.value !== null && control.value !== '';
      });

      if (allValid) {
        completedSteps++;
      }
    }

    this.progress = Math.round((completedSteps / totalSteps) * 100);
  }




  // getConicGradient(): string {
  //   const progress = Math.max(this.progress);
  //   return `conic-gradient(#004aad ${progress}%, #d9d9d9 ${progress}% 100%)`;
  // }

  getConicGradient(): string {
    const progress = this.progress;
    return `conic-gradient(#004aad ${progress}%, #d9d9d9 ${progress}% 100%)`;
  }

}
